import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Add this import
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { db, collection, query, where, deleteDoc, onSnapshot, doc, updateDoc, setDoc, getDocs, writeBatch, getDoc } from '../firebaseConfig';
import 'react-datepicker/dist/react-datepicker.css';
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfYear, endOfYear, isWithinInterval } from 'date-fns';
import './JournalTable.css';
import MDButton from "components/MDButton";
import { useTheme } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import EditSingleTrade from './EditSingleTrade';
import MDTypography from "components/MDTypography";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { calculatePipIncrement, getBaseCurrency, getQuoteCurrency, getExchangeRate, fetchExchangeRate, getExchangeRateSymbol } from './TradeEntryForm';
import { Delete, Edit, FindReplace } from '@mui/icons-material';
import {
  Paper,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';  // Fixed import
import { v4 as uuidv4 } from 'uuid';
import UploadIcon from '@mui/icons-material/Upload';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';
import { detectAssetType } from "./TradeEntryForm"; 

const JournalTable = ({ userID, selectedAccountID, tradeAccounts }) => {
  const navigate = useNavigate(); // Add this hook
  const [journalEntries, setJournalEntries] = useState([]);
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [filterBySymbol, setFilterBySymbol] = useState('');
  const [filterByConfidence, setFilterByConfidence] = useState('');
  const [filterByResult, setFilterByResult] = useState('');
  const [filterByDate, setFilterByDate] = useState('');
  const [filterByStatus, setFilterByStatus] = useState('');
  const [filterByTags, setFilterByTags] = useState('');
  const [filterByTradeScore, setFilterByTradeScore] = useState("All");
  const [filterByFees, setFilterByFees] = useState('');
  const [selectedEntries, setSelectedEntries] = useState([]);
  const [subFilterByDate, setSubFilterByDate] = useState('');
  const [editData, setEditData] = useState(null);
  const [updatedSlValue, setUpdatedSlValue] = useState('');
  const [exit, setExit] = useState('');
  const [entry, setEntry] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [comments, setComments] = useState('');
  const [sl, setSl] = useState('');
  const [tp, setTp] = useState('');
  const [status, setStatus] = useState('');
  const [tradeConfidence, setTradeConfidence] = useState('');
  const [exchangeRate, setExchangeRate] = useState('');
  const [containsUSD, setContainsUSD] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [manualReturns, setManualReturns] = useState('');
  const [showManualOverrideModal, setShowManualOverrideModal] = useState(false);
  const [overrideData, setOverrideData] = useState(null);
  const [manualOverrideValue, setManualOverrideValue] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [checklist, setChecklist] = useState(null);
  const [checklistResponses, setChecklistResponses] = useState([]);
  const [isChecklistModalOpen, setIsChecklistModalOpen] = useState(false);
  const [fxbTradeScore, setFxbTradeScore] = useState('N/A'); // Add state for Trade Score
  const [filterByMonth, setFilterByMonth] = useState("All");
  const [tradingViewTradeID, setTradingViewTradeID] = useState(null);
  const [filterByYear, setFilterByYear] = useState("All");
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [selectedTradeURL, setSelectedTradeURL] = useState(null);
const [tradingViewUrls, setTradingViewUrls] = useState({
  htf: '',
  ltf: '',
  extra:'',
});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exitDate, setExitDate] = useState('');
  const [exitTime, setExitTime] = useState('');
  const [entryDate, setEntryDate] = useState('');
  const [date, setDate] = useState('');
  const [entryTime, setEntryTime] = useState('');
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [commission, setCommission] = useState(0);
  const [commissionType, setCommissionType] = useState('dollar');
  const tableRef = useRef(null);
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showMassEditModal, setShowMassEditModal] = useState(false);
  const [currentMassEditTrade, setCurrentMassEditTrade] = useState(null);
  const [massEditConfidence, setMassEditConfidence] = useState('');
  const [massEditTags, setMassEditTags] = useState('');
  const [showMoveTradeModal, setShowMoveTradeModal] = useState(false);
  const [showTradingViewModal, setShowTradingViewModal] = useState(false);
  const [tempTradingViewUrl, setTempTradingViewUrl] = useState('');
  const [targetAccountID, setTargetAccountID] = useState('');
  const [tradesToMove, setTradesToMove] = useState([]);
  const [previewTimeframe, setPreviewTimeframe] = useState('htf');
  const [massEditStatus, setMassEditStatus] = useState('');
  const topScrollRef = useRef(null);
const tableWrapperRef = useRef(null);


const handleTopScroll = () => {
  if (topScrollRef.current && tableWrapperRef.current) {
    tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
  }
};

const handleTableScroll = () => {
  if (topScrollRef.current && tableWrapperRef.current) {
    topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
  }
};

useEffect(() => {
  const updateScrollWidth = () => {
    if (topScrollRef.current && tableRef.current) {
      topScrollRef.current.firstChild.style.width = `${tableRef.current.scrollWidth}px`;
    }
  };
  updateScrollWidth();
  window.addEventListener('resize', updateScrollWidth);
  return () => window.removeEventListener('resize', updateScrollWidth);
}, [journalEntries]);
  const iconColor = theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600];


  useEffect(() => {
    if (!userID || !selectedAccountID) return;

    const fetchData = async () => {
      try {
        const tradesPath = `Users/${userID}/tradeAccounts/${selectedAccountID}/trades`;
        const q = query(collection(db, tradesPath), where('userID', '==', userID));
        const observer = onSnapshot(q, (querySnapshot) => {
          const entries = querySnapshot.docs.map(doc => {
            const data = doc.data();
            const risk = Math.abs(parseFloat(data.entry) - parseFloat(data.sl));
            const reward = Math.abs(parseFloat(data.tp) - parseFloat(data.entry));
            const riskRewardRatio = risk ? (reward / risk) : 0;

// Helper function to parse and combine date/time
          const getEntryDateTime = (entryDateTime, date, entryTime) => {
            // Try entryDateTime first
            if (entryDateTime) {
              const parsed = new Date(entryDateTime);
              if (!isNaN(parsed.getTime())) {
                return parsed.toISOString();
              }
            }
            // Fallback to date and entryTime
            if (date) {
              let dateTimeString = date;
              if (entryTime) {
                // Ensure entryTime includes seconds (e.g., "11:31" -> "11:31:00")
                const timeParts = entryTime.split(':');
                const formattedTime = timeParts.length === 2 ? `${entryTime}:00` : entryTime;
                dateTimeString = `${date}T${formattedTime}`;
              } else {
                // If no entryTime, use midnight
                dateTimeString = `${date}T00:00:00`;
              }
              const parsed = new Date(dateTimeString);
              if (!isNaN(parsed.getTime())) {
                return parsed.toISOString();
              }
            }
            // Log for debugging
            console.warn(`Invalid entryDateTime for trade ${doc.id}:`, {
              entryDateTime,
              date,
              entryTime,
            });
            return 'N/A';
          };

          const entryDateTime = getEntryDateTime(
            data.entryDateTime,
            data.date,
            data.entryTime
          );

          const exitDateTime = data.exitDateTime && !isNaN(new Date(data.exitDateTime).getTime())
            ? data.exitDateTime
            : (data.exitDate && data.exitDate !== '' && !isNaN(new Date(data.exitDate).getTime()))
              ? (data.exitTime && data.exitTime !== '' ? `${data.exitDate}T${data.exitTime}` : data.exitDate)
              : 'N/A';
            let actualRRRatio = 'N/A';
            if (data.status !== 'Open' && data.exit) {
              const actualReward = Math.abs(parseFloat(data.exit) - parseFloat(data.entry));
              const isLoss = data.shortLong === 'Long'
                ? parseFloat(data.exit) < parseFloat(data.entry)
                : parseFloat(data.exit) > parseFloat(data.entry);
              actualRRRatio = risk
                ? (isLoss ? -1 * (actualReward / risk).toFixed(2) : (actualReward / risk).toFixed(2))
                : 'N/A';
            }

            return {
              ...data,
              id: doc.id,
              date: data.date || 'N/A',
              status: data.status || 'N/A',
              entryTime: data.entryTime || 'N/A',
              exitDate: data.exitDate || 'N/A',
              exitTime: data.exitTime || 'N/A',
              symbol: data.symbol || 'N/A',
              entry: data.entry || 'N/A',
              exit: data.exit || 'N/A',
              returns: data.returns !== null && data.returns !== undefined && !isNaN(data.returns) ? data.returns : 'N/A',
              sl: data.sl || 'N/A',
              tp: data.tp || 'N/A',
              comments: data.comments || 'N/A',
              returnPercentage: parseFloat(data.returnPercentage) || 0,
              riskRewardRatio: parseFloat(riskRewardRatio.toFixed(2)) || 0,
              actualRRRatio,
              entryDateTime,
              exitDateTime,
              fxbTradeScore: data.fxbTradeScore || 'N/A',
              tradeConfidence: data.tradeConfidence || 'N/A',
              commission: data.commission || 0,
tradingViewUrls: {
  htf: data.tradingViewUrls?.htf || (data.tradingViewUrl ? data.tradingViewUrl : ""),
  ltf: data.tradingViewUrls?.ltf || "",
  extra: data.tradingViewUrls?.extra || "",
},
            };
          });
          setJournalEntries(entries);
        });
        return () => observer();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [userID, selectedAccountID]);

  useEffect(() => {
    const fetchTags = async () => {
      const tagCollectionRef = collection(db, "Users", userID, "tags");
      try {
        const tagSnapshot = await getDocs(tagCollectionRef);
        const fetchedTags = tagSnapshot.docs.map(doc => doc.id);
        setTags(fetchedTags);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };

    fetchTags();
  }, [userID]);

  const uniqueSymbols = [...new Set(journalEntries.map(entry => entry.symbol))];
  const allTags = journalEntries.flatMap(entry => entry.tags || []);
  const uniqueTags = [...new Set(allTags)];
  const uniqueStatus = [...new Set(journalEntries.map(entry => entry.status))];

  const handleSort = (header) => {
    if (sortBy === header) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(header);
      setSortOrder('asc');
    }
  };

const getPreviewUrl = (trade) =>
  trade.tradingViewUrls?.htf ||
  trade.tradingViewUrls?.ltf ||
  trade.tradingViewUrls?.extra ||
  null;
  
const handleUploadImage = async (tradeID, file) => {
    const storage = getStorage();
    const storageRef = ref(storage, `trades/${tradeID}/${uuidv4()}`);
    
    try {
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);

      const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradeID);
      await updateDoc(docRef, { screenshot: imageUrl });
      console.log('Image uploaded successfully');
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const handleAddTag = async (tag) => {
    const trimmedTag = tag.trim();
    if (trimmedTag && !tags.includes(trimmedTag)) {
      const tagCollectionRef = collection(db, "Users", userID, "tags");
      const tagDocRef = doc(tagCollectionRef, trimmedTag);
      try {
        await setDoc(tagDocRef, { tag: trimmedTag });
        setTags(prevTags => [...prevTags, trimmedTag]);
        setSelectedTags(prevTags => [...prevTags, trimmedTag]);
      } catch (error) {
        console.error("Error adding tag:", error);
      }
    }
  };

  const updateTradeTags = async (tradeID, newTags) => {
    const tradeDocRef = doc(db, "Users", userID, "tradeAccounts", selectedAccountID, "trades", tradeID);
    try {
      await setDoc(tradeDocRef, { tags: newTags }, { merge: true });
    } catch (error) {
      console.error("Error updating trade tags:", error);
    }
  };

  const closeModal = (event) => {
    if (tableRef.current && (event.target.closest('.actions') || event.target.closest('.upload-button') || event.target.closest('.manual-override-button'))) {
      return;
    }
    setIsModalOpen(false);
    setSelectedTrade(null);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allEntryIds = journalEntries.map(entry => entry.id);
      setSelectedEntries(allEntryIds);
    } else {
      setSelectedEntries([]);
    }
  };

  const handleSelectEntry = (e, id) => {
    if (e.target.checked) {
      setSelectedEntries(prevSelected => [...prevSelected, id]);
    } else {
      setSelectedEntries(prevSelected => prevSelected.filter(entryId => entryId !== id));
    }
  };

  const handleRowClick = (entry, event) => {
    console.log('Setting selectedTrade:', entry);

    // Apply failsafes for missing data
    const safeTrade = {
      ...entry,
      entryDateTime: entry.entryDateTime || 'N/A',
      exitDate: entry.exitDate || 'N/A',
      exitTime: entry.exitTime || 'N/A',
      symbol: entry.symbol || 'N/A',
      entry: entry.entry !== null && entry.entry !== undefined ? entry.entry : 0,
      exit: entry.exit !== null && entry.exit !== undefined ? entry.exit : 0,
      sl: entry.sl !== null && entry.sl !== undefined ? entry.sl : 0,
      tp: entry.tp !== null && entry.tp !== undefined ? entry.tp : 0,
      leverage: entry.leverage !== null && entry.leverage !== undefined ? entry.leverage : 0,
      sizeType: entry.sizeType || 'N/A',
      lotSizeEntry: entry.lotSizeEntry !== null && entry.lotSizeEntry !== undefined ? entry.lotSizeEntry : 0,
      sizeAmount: entry.sizeAmount !== null && entry.sizeAmount !== undefined ? entry.sizeAmount : 0,
      shortLong: entry.shortLong || 'N/A',
      returns: entry.returns !== null && entry.returns !== undefined && !isNaN(entry.returns) ? entry.returns : 0,
      returnPercentage: entry.returnPercentage !== null && entry.returnPercentage !== undefined ? entry.returnPercentage : 0,
      riskAmount: entry.riskAmount !== null && entry.riskAmount !== undefined ? entry.riskAmount : 0,
      riskRewardRatio: entry.riskRewardRatio !== null && entry.riskRewardRatio !== undefined ? entry.riskRewardRatio : 0,
      actualRRRatio: entry.actualRRRatio || 'N/A',
      status: entry.status || 'N/A',
      tradeConfidence: entry.tradeConfidence || 'N/A',
      fxbTradeScore: entry.fxbTradeScore || 'N/A',
      tags: Array.isArray(entry.tags) ? entry.tags : [],
      commission: entry.commission !== null && entry.commission !== undefined ? entry.commission : 0,
      comments: entry.comments || 'N/A',
      screenshot: entry.screenshot || null,
  tradingViewUrls: entry.tradingViewUrls || {},
    };

    setSelectedTrade(safeTrade);
    setPreviewTimeframe('htf');
    setSelectedTradeURL(
  safeTrade.screenshot ||
  safeTrade.tradingViewUrls?.htf ||
  safeTrade.tradingViewUrls?.ltf ||
  safeTrade.tradingViewUrls?.extra ||
  null
);
    setIsModalOpen(true);
  };
  
  const handleFilterBySymbol = (symbol) => {
    setFilterBySymbol(symbol === "All" ? "" : symbol);
  };

  const handleFilterByTags = (tags) => {
    setFilterByTags(tags === "All" ? "" : tags);
  };

  const handleFilterByFees = (fees) => {
    setFilterByFees(fees === "All" ? "" : fees);
  };

  const handleFilterByConfidence = (confidence) => {
    setFilterByConfidence(confidence === "All" ? "" : confidence);
  };

  const handleMenuOpen = (event, entry) => {
    setAnchorEl(event.currentTarget);
    setSelectedTrade(entry);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTrade(null);
  };

  const handleFilterByResult = (result) => {
    setFilterByResult(result === "All" ? "" : result);
  };

  const handleFilterByDate = (date) => {
    setFilterByDate(date);
  };

  const handleSubFilterByDate = (subFilter) => {
    setSubFilterByDate(subFilter === "All" ? "" : subFilter);
  };

  const handleFilterByStatus = (status) => {
    setFilterByStatus(status === "All" ? "" : status);
  };

  const handleFilterByMonth = (value) => {
    console.log("Selected Month:", value);
    setFilterByMonth(value);
  };

  const handleFilterByYear = (value) => {
    console.log("Selected Year:", value);
    setFilterByYear(value);
  };

  const handleDelete = async (tradeID) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this row? This action is not reversible!');
    if (confirmDelete) {
      try {
        const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradeID);
        await deleteDoc(docRef);
        setJournalEntries(prevEntries => prevEntries.filter(entry => entry.id !== tradeID));
      } catch (error) {
        console.error('Error deleting entry from database:', error);
      }
    }
  };

  const handleBulkDelete = async () => {
    const confirmDelete = window.confirm('Are you sure you want to delete the selected trade entries? This action is not reversible!');
    if (confirmDelete) {
      try {
        for (const tradeID of selectedEntries) {
          const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradeID);
          await deleteDoc(docRef);
        }
        setJournalEntries(prevEntries => prevEntries.filter(entry => !selectedEntries.includes(entry.id)));
        setSelectedEntries([]);
      } catch (error) {
        console.error('Error deleting entries from database:', error);
      }
    }
  };

  const handleEdit = (entry) => {
    setEditData(entry);
    setShowModal(true);
    setEntry(entry.entry || '');
    setExit(entry.exit || '');
    setComments(entry.comments || '');
    setStatus(entry.status || '');
    setManualReturns(entry.manualReturns || '');
    setDate(entry.date || '');
    setEntryTime(entry.entryTime || '');
    setSl(entry.sl || '');
    setTradeConfidence(entry.tradeConfidence || '');
    setUpdatedSlValue(entry.sl || '');
    setTp(entry.tp || '');
    setTradingViewUrls(entry.tradingViewUrls || { htf: '', ltf: '', extra: '', });
    setFxbTradeScore(entry.fxbTradeScore || 'N/A'); // Initialize Trade Score
    setChecklistResponses(entry.checklistResponses || (checklist?.items ? new Array(checklist.items.length).fill(false) : [])); // Initialize responses
    const existingTags = Array.isArray(entry.tags) ? entry.tags.join(', ') : '';
    setTags(existingTags);

    if (entry.exitDateTime && !isNaN(new Date(entry.exitDateTime).getTime())) {
      const dateObj = new Date(entry.exitDateTime);
      setExitDate(dateObj.toISOString().split('T')[0]);
      setExitTime(dateObj.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' }));
    } else if (entry.exitDate) {
      setExitDate(entry.exitDate);
      setExitTime(entry.exitTime || '');
    } else {
      setExitDate('');
      setExitTime('');
    }

    const containsUSD = entry.symbol.toUpperCase().includes('USD');
    setContainsUSD(containsUSD);
    if (!containsUSD) {
      setExchangeRate(entry.exchangeRate || '');
    } else {
      setExchangeRate('');
    }
    setSelectedTags(entry.tags || []);
  };

  const handleManualOverride = (entry) => {
    const confirmOverride = window.confirm('Warning: This action cannot be undone. Are you sure you want to proceed with the manual override?');
    if (confirmOverride) {
      setOverrideData(entry);
      setShowManualOverrideModal(true);
      setManualOverrideValue('');
      setDate(entry.date || ''); // Set the date state
    }
  };

  const confirmManualOverride = async () => {
    try {
      const manualReturnValue = parseFloat(manualOverrideValue);
      if (isNaN(manualReturnValue)) {
        alert('Please enter a valid number for the manual return.');
        return;
      }

      const updatedEntryData = {
        ...overrideData,
        manualReturns: manualReturnValue,
        returns: manualReturnValue
      };

      const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', overrideData.id);
      await updateDoc(docRef, updatedEntryData);

      setShowManualOverrideModal(false);
      setOverrideData(null);
    } catch (error) {
      console.error('Error overriding returns:', error);
    }
  };

  const renderTradeScore = (fxbTradeScore) => {
    if (fxbTradeScore === 'N/A') {
      return <MDTypography variant="body3">N/A</MDTypography>;
    }

    const [score, rest] = fxbTradeScore.split('/');
    const scoreNum = parseInt(score, 10);

    let color;
    if (scoreNum >= 80) color = 'success';
    else if (scoreNum >= 50) color = 'warning';
    else color = 'error';

    return (
      <MDTypography variant="body3">
        <span style={{ color: theme.palette[color].main }}>{score}</span>
        <span>/{rest}</span>
      </MDTypography>
    );
  };

  const getConfidenceIcon = (confidence) => {
    if (!confidence) {
      return <MDTypography variant="body3">N/A</MDTypography>;
    }
    switch (confidence) {
      case 'High':
        return <SentimentVerySatisfiedIcon color="success" style={{ fontSize: 30 }} />;
      case 'Medium':
        return <SentimentSatisfiedIcon color="warning" style={{ fontSize: 30 }} />;
      case 'Low':
        return <SentimentDissatisfiedIcon color="error" style={{ fontSize: 30 }} />;
      default:
        return <MDTypography variant="body3">N/A</MDTypography>;
    }
  };

  const handleTagChange = (e) => {
    const newTags = e.target.value;
    if (typeof newTags === 'string') {
      setTags(newTags);
    } else {
      console.error('Tags should be a string');
    }
  };

  const handleMoveTrades = async (tradeIDs) => {
    if (!targetAccountID) {
      alert('Please select a target account.');
      return;
    }
  
    const confirmMove = window.confirm(`Are you sure you want to move ${tradeIDs.length} trade(s) to the selected account? This action cannot be undone.`);
    if (!confirmMove) return;
  
    try {
      const batch = writeBatch(db);
      for (const tradeID of tradeIDs) {
        const sourceTradeRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradeID);
        const targetTradeRef = doc(db, 'Users', userID, 'tradeAccounts', targetAccountID, 'trades', tradeID);
        const tradeData = (await getDoc(sourceTradeRef)).data();
        batch.set(targetTradeRef, tradeData);
        batch.delete(sourceTradeRef);
      }
      await batch.commit();
  
      setJournalEntries((prevEntries) => prevEntries.filter((entry) => !tradeIDs.includes(entry.id)));
      setSelectedEntries((prevSelected) => prevSelected.filter((id) => !tradeIDs.includes(id)));
      alert('Trade(s) moved successfully!');
      setShowMoveTradeModal(false);
      setTradesToMove([]);
      setTargetAccountID('');
    } catch (error) {
      console.error('Error moving trades:', error);
      alert('Failed to move trade(s).');
    }
  };

  const calculateHoldTime = (entryDateTime, exitDate, exitTime) => {
    if (!entryDateTime || !exitDate) return 'N/A';

    const entryDate = new Date(entryDateTime);
    const exitDateTime = new Date(exitDate + 'T' + (exitTime || '00:00'));

    const diffMs = exitDateTime - entryDate;
    if (diffMs <= 0) return 'N/A';

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffDays} days ${diffHours} hours ${diffMinutes} minutes`;
  };

  const handleMassUpdate = async () => {
    try {
      const updates = {};
      if (massEditConfidence) updates.tradeConfidence = massEditConfidence;
      if (massEditTags) updates.tags = massEditTags.split(',').map(tag => tag.trim()).filter(tag => tag);
      if (massEditStatus) updates.status = massEditStatus;

      if (Object.keys(updates).length === 0) {
        alert('Please select at least one field to update.');
        return;
      }

      for (const tradeID of selectedEntries) {
        const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradeID);
        await updateDoc(docRef, updates);
      }

      setShowMassEditModal(false);
      setMassEditConfidence('');
      setMassEditTags('');
      setMassEditStatus('');
    } catch (error) {
      console.error('Error during mass update:', error);
      alert('Failed to update trades.');
    }
  };

  const handleMassEditStart = () => {
    if (selectedEntries.length === 0) return;
    const firstTradeId = selectedEntries[0];
    const firstTrade = journalEntries.find(entry => entry.id === firstTradeId);
    setCurrentMassEditTrade({ trade: firstTrade, index: 0 });
    handleEdit(firstTrade);
  };

const handleSaveTradingViewUrl = async () => {
  try {
    const htf = (tradingViewUrls.htf || '').trim();
    const ltf = (tradingViewUrls.ltf || '').trim();
    const extra = (tradingViewUrls.extra || '').trim();

    if (!htf && !ltf && !extra) {
      alert('Please enter at least one TradingView URL.');
      return;
    }

    const regex = /^https:\/\/(www\.)?tradingview\.com\/x\/[A-Za-z0-9_-]+\/?$/i;
    if ((htf && !regex.test(htf)) ||  (ltf && !regex.test(ltf)) ||  (extra && !regex.test(extra))) {
      alert('Please enter a valid TradingView snapshot URL (e.g., https://www.tradingview.com/x/abc123/).');
      return;
    }

    if (!tradingViewTradeID) {
      alert('No trade selected. Please try again.');
      return;
    }

    const docRef = doc(db, 'Users', userID, 'tradeAccounts', selectedAccountID, 'trades', tradingViewTradeID);

    const updateData = {};
    if (htf) updateData['tradingViewUrls.htf'] = htf;
    if (ltf) updateData['tradingViewUrls.ltf'] = ltf;
    if (extra) updateData['tradingViewUrls.extra'] = extra;

    await updateDoc(docRef, updateData);

    alert('TradingView URL(s) saved successfully!');
    setShowTradingViewModal(false);
    setTradingViewTradeID(null);
    setTradingViewUrls({ htf: '', ltf: '', extra:'', });
  } catch (error) {
    console.error('Error saving TradingView URL:', error);
    alert('Failed to save TradingView URL.');
  }
};


const handleUpdate = async () => {
  try {
    const updatedExit = parseFloat(exit);
    const updatedEntry = parseFloat(entry);
    const updatedLeverage = parseFloat(editData.leverage);

    const sizeType = editData.sizeType;
    const lotSizeEntry = parseFloat(editData.lotSizeEntry);
    const sizeAmount = parseFloat(editData.sizeAmount);

    const updatedSl = updatedSlValue || editData.sl;
    const updatedTp = tp || editData.tp;

    const direction = editData.shortLong?.toLowerCase() === "short" ? -1 : 1;
    const symbol =
      editData.symbol?.toUpperCase() === "DAX"
        ? "GER40"
        : (editData.symbol || "").toUpperCase();

    const commissionValue = editData.commissionValue;

    // -----------------------------
    // Checklist validation
    // -----------------------------
    if (checklist && checklistResponses.length !== checklist.items.length) {
      alert("Checklist responses do not match checklist items. Please try again.");
      return;
    }

    // -----------------------------
    // Asset-aware size validation
    // -----------------------------
    const assetType = detectAssetType(symbol);

    if (assetType === "equity") {
      const shares = parseFloat(editData.shareCount);
      if (isNaN(shares) || shares <= 0) {
        alert("Please enter a valid positive number of shares.");
        return;
      }
    } else if (assetType === "futures") {
      if (isNaN(lotSizeEntry) || lotSizeEntry <= 0) {
        alert("Please enter a valid positive number of contracts.");
        return;
      }
    } else {
      // Forex
      if (sizeType === "lot") {
        if (isNaN(lotSizeEntry) || lotSizeEntry <= 0) {
          alert("Please enter a valid positive lot size.");
          return;
        }
      } else if (sizeType === "dollar") {
        if (isNaN(sizeAmount) || sizeAmount <= 0) {
          alert("Please enter a valid positive dollar amount.");
          return;
        }
        if (isNaN(updatedLeverage) || updatedLeverage <= 0) {
          alert("Please enter a valid positive leverage.");
          return;
        }
      }
    }

    // -----------------------------
    // Status-based validation
    // -----------------------------
    if (["Closed", "Missed"].includes(status)) {
      if (!exit || isNaN(updatedExit)) {
        alert("Please enter a valid exit price for a Closed or Missed trade.");
        return;
      }
      if (!exitDate || isNaN(new Date(exitDate).getTime())) {
        alert("Please enter a valid exit date for a Closed or Missed trade.");
        return;
      }
    }

    const newEntryDate = entryDate !== "" ? entryDate : editData.date;

    // -----------------------------
    // Exchange rate logic (FOREX CROSS ONLY)
    // -----------------------------
    let exchangeRateValue = 1;

    const isForex = assetType === "forex";
    const isClosedOrMissed = ["Closed", "Missed"].includes(status);

    const base = getBaseCurrency(symbol);
    const quote = getQuoteCurrency(symbol);

    const isUsdInPair =
      symbol.includes("USD") || base === "USD" || quote === "USD";

    // Only forex non-USD crosses need exchange rates (e.g., EURGBP)
    const needsExchangeRate = isForex && isClosedOrMissed && !isUsdInPair;

    if (!needsExchangeRate) {
      exchangeRateValue = 1;
    } else {
      const manual = parseFloat(exchangeRate);
      const existing = parseFloat(editData.exchangeRate);

      if (!isNaN(manual) && manual > 0) {
        exchangeRateValue = manual;
      } else {
        const exchangeRateSymbol = getExchangeRateSymbol(editData);
        const fetchedRate = await fetchExchangeRate(exchangeRateSymbol);

        if (fetchedRate && fetchedRate > 0) {
          exchangeRateValue = fetchedRate;
          setExchangeRate(String(fetchedRate)); // optional UI sync
        } else if (!isNaN(existing) && existing > 0) {
          exchangeRateValue = existing;
        } else {
          // last resort: forex cross missing + not fetchable
          exchangeRateValue = 1;
          console.warn(
            `Failed to fetch ${exchangeRateSymbol} and no existing rate; falling back to 1`
          );
        }
      }
    }

    // -----------------------------
    // Returns / Risk calculation
    // -----------------------------
    let returns = editData.returns;
    let returnPercentage = 0;
    let riskAmount = 0;

    const isAutoUploaded = editData.comments === "Auto-Uploaded Data";

    // Futures $ per 1.00 move multipliers (matches what you used in the form)
    const futuresPointValue = {
      ES_F: 50,
      NQ_F: 20,
      YM_F: 5,
      RTY_F: 50,
      CL_F: 1000,
      GC_F: 100,
      SI_F: 5000,
      HG_F: 25,
      ZB_F: 1000,
      ZN_F: 1000,
      ZF_F: 1000,
      RB_F: 42000,
      HO_F: 42000,
      PL_F: 50,
      PA_F: 100,
    };

    if (!isAutoUploaded) {
      // Only compute returns when we actually have an exit
      const hasExit = ["Closed", "Missed"].includes(status) && !isNaN(updatedExit);

      if (!hasExit) {
        // If open, keep existing returns as-is
        returns = editData.returns;
        returnPercentage = editData.returnPercentage || 0;
        riskAmount = editData.riskAmount || 0;
      } else if (assetType === "equity") {
        const shares = parseFloat(editData.shareCount) || 0;

        // Returns in $ for equities
        const rawMove = (updatedExit - updatedEntry) * direction;
        returns = rawMove * shares;

        // Risk amount based on SL if provided
        if (updatedSl && !isNaN(parseFloat(updatedSl))) {
          const moveToSL = (parseFloat(updatedSl) - updatedEntry) * direction;
          riskAmount = Math.abs(moveToSL) * shares;
        }

        returnPercentage =
          ((updatedExit - updatedEntry) / Math.abs(updatedEntry)) * 100 * direction;
      } else if (assetType === "futures") {
        const contracts = parseFloat(editData.lotSizeEntry) || 0;
        const pv = futuresPointValue[symbol] || 1; // fallback if missing

        const rawMove = (updatedExit - updatedEntry) * direction;
        returns = rawMove * contracts * pv;

        if (updatedSl && !isNaN(parseFloat(updatedSl))) {
          const moveToSL = (parseFloat(updatedSl) - updatedEntry) * direction;
          riskAmount = Math.abs(moveToSL) * contracts * pv;
        }

        returnPercentage =
          ((updatedExit - updatedEntry) / Math.abs(updatedEntry)) * 100 * direction;
      } else {
        // -----------------------------
        // Forex / CFDs (your existing logic)
        // -----------------------------
        const pipIncrement = calculatePipIncrement(symbol);
        const pipDifference = ((updatedExit - updatedEntry) / pipIncrement) * direction;

        if (
          [
            "XAUUSD",
            "US30",
            "SPX500",
            "NAS100",
            "UK100",
            "GER40",
            "XAGUSD",
            "XPTUSD",
            "XPDUSD",
            "WTIUSD",
            "BRENTUSD",
            "NGASUSD",
            "COFFEEUSD",
            "COTTONUSD",
          ].includes(symbol)
        ) {
          const pipAmount = Math.abs(pipDifference);
          const contractSize = symbol === "US30" ? 5 : 1;

          const effectiveExchangeRate =
            symbol === "US30" || symbol.includes("USD") ? 1 : exchangeRateValue;

          returns =
            (pipAmount * lotSizeEntry * contractSize * Math.sign(pipDifference)) /
            effectiveExchangeRate;

          const pipsToSL =
            ((parseFloat(updatedSl) - updatedEntry) / pipIncrement) * direction;

          riskAmount =
            (Math.abs(pipsToSL) * lotSizeEntry * contractSize) / effectiveExchangeRate;
        } else {
          const pipAmount = Math.abs(pipDifference) * 10;

          returns =
            (pipAmount * lotSizeEntry * Math.sign(pipDifference)) / exchangeRateValue;

          const pipsToSL =
            ((parseFloat(updatedSl) - updatedEntry) / pipIncrement) * direction;

          riskAmount =
            (Math.abs(pipsToSL) * lotSizeEntry * 10) / exchangeRateValue;

          if (quote === "JPY") {
            returns *= 100;
            riskAmount *= 100;
          }
        }

        returnPercentage =
          ((updatedExit - updatedEntry) / Math.abs(updatedEntry)) * 100 * direction;
      }
    } else {
      // Auto-uploaded: preserve returns; compute minimal extras safely
      if (["Closed", "Missed"].includes(status) && !isNaN(updatedExit)) {
        returnPercentage =
          ((updatedExit - updatedEntry) / Math.abs(updatedEntry)) * 100 * direction;
      } else {
        returnPercentage = editData.returnPercentage || 0;
      }

      // Preserve riskAmount unless you want to recalc; keeping your old behavior:
      riskAmount = editData.riskAmount || 0;
      returns = editData.returns;
    }

    // -----------------------------
    // Commission (only when not auto-uploaded)
    // -----------------------------
    if (!isAutoUploaded) {
      if (commissionType === "percentage" && commissionValue) {
        if (returns > 0) {
          const commissionPercent = parseFloat(commissionValue) / 100;
          returns = returns * (1 - commissionPercent);
        }
      } else if (commissionType === "dollar" && commissionValue) {
        const commissionAmount = parseFloat(commissionValue);
        returns = returns - commissionAmount;
      }
    }

    // -----------------------------
    // RR
    // -----------------------------
    const targetedRR =
      updatedTp && !isNaN(parseFloat(updatedTp))
        ? (parseFloat(updatedTp) - updatedEntry) /
          (updatedEntry - parseFloat(updatedSl))
        : 0;

    const actualRR = riskAmount ? returns / riskAmount : 0;

    // -----------------------------
    // Tags
    // -----------------------------
    const tagsArray =
      typeof tags === "string"
        ? tags
            .split(",")
            .map((t) => t.trim())
            .filter((t) => t.length > 0)
        : [];

    // -----------------------------
    // DateTimes
    // -----------------------------
    const formattedEntryTime =
      entryTime && entryTime.length === 5 ? `${entryTime}:00` : entryTime || "00:00:00";
    const entryDateTime = new Date(`${newEntryDate}T${formattedEntryTime}`).toISOString();

    let exitDateTime = null;
    if (exitDate && !isNaN(new Date(exitDate).getTime())) {
      const formattedExitTime =
        exitTime && exitTime.length === 5 ? `${exitTime}:00` : exitTime || "00:00:00";
      exitDateTime = new Date(`${exitDate}T${formattedExitTime}`).toISOString();
    }

    // -----------------------------
    // Build update payload
    // -----------------------------
    const updatedEntryData = {
      ...editData,
      entry: updatedEntry,
      exit: updatedExit,
      comments,
      status,

      returns: !isNaN(returns) ? parseFloat(Number(returns).toFixed(2)) : 0,
      returnPercentage: !isNaN(returnPercentage)
        ? parseFloat(Number(returnPercentage).toFixed(2))
        : 0,
      riskAmount: !isNaN(riskAmount) ? parseFloat(Number(riskAmount).toFixed(2)) : 0,

      // ✅ Only store a rate for forex-cross needs; otherwise keep "1"
      exchangeRate: needsExchangeRate ? Number(exchangeRateValue).toFixed(5) : "1",

      date: date,
      entryTime: entryTime,
      entryDateTime,
      exitDate: exitDate,
      exitTime: exitTime,
      exitDateTime,

      tags: tagsArray,
      sl: updatedSl,
      tp: updatedTp || "",
      tradeConfidence: tradeConfidence,
      targetedRR: targetedRR.toFixed(2),
      actualRR: actualRR.toFixed(2),
      tradingViewUrls: tradingViewUrls || "",
      fxbTradeScore: fxbTradeScore || "N/A",
      checklistResponses: checklistResponses || null,

      symbol: symbol,
    };

    console.log("Updating document with data:", updatedEntryData);

    const docRef = doc(
      db,
      "Users",
      userID,
      "tradeAccounts",
      selectedAccountID,
      "trades",
      editData.id
    );

    await updateDoc(docRef, updatedEntryData);

    setJournalEntries((prevEntries) =>
      prevEntries.map((t) => (t.id === editData.id ? { ...t, ...updatedEntryData } : t))
    );

    if (currentMassEditTrade) {
      const nextIndex = currentMassEditTrade.index + 1;
      if (nextIndex < selectedEntries.length) {
        const nextTradeId = selectedEntries[nextIndex];
        const nextTrade = journalEntries.find((t) => t.id === nextTradeId);
        setCurrentMassEditTrade({ trade: nextTrade, index: nextIndex });
        handleEdit(nextTrade);
      } else {
        setCurrentMassEditTrade(null);
        setShowModal(false);
        setSelectedEntries([]);
      }
    } else {
      setShowModal(false);
    }
  } catch (error) {
    console.error("Error updating entry:", error);
  }
};

  const getYearsArray = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };

  const currentYear = new Date().getFullYear();
  const years = getYearsArray(2022, currentYear);

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const filteredEntries = () => {
    let filtered = [...journalEntries];

    if (filterBySymbol) {
      filtered = filtered.filter(entry => entry.symbol === filterBySymbol);
    }

    if (filterByFees) {
      filtered = filtered.filter(entry => entry.commission === filterByFees);
    }

    if (filterByTags) {
      filtered = filtered.filter(entry => {
        const tags = Array.isArray(entry.tags) ? entry.tags : [];
        return tags.includes(filterByTags);
      });
    }
    if (filterByStatus) {
      filtered = filtered.filter(entry => entry.status === filterByStatus);
    }

    if (filterByTradeScore && filterByTradeScore !== "All") {
      filtered = filtered.filter(entry => {
        const score = entry.fxbTradeScore === 'N/A' ? 0 : parseInt(entry.fxbTradeScore.split('/')[0], 10);
        if (filterByTradeScore === "80-100") return score >= 80;
        if (filterByTradeScore === "50-79") return score >= 50 && score < 80;
        if (filterByTradeScore === "<50") return score < 50;
        return true;
      });
    }

    if (filterByConfidence === 'High') {
      filtered = filtered.filter(entry => entry.tradeConfidence === 'High');
    } else if (filterByConfidence === 'Medium') {
      filtered = filtered.filter(entry => entry.tradeConfidence === 'Medium');
    } else if (filterByConfidence === 'Low') {
      filtered = filtered.filter(entry => entry.tradeConfidence === 'Low');
    }

    if (filterByResult === 'wins') {
      filtered = filtered.filter(entry => entry.returns >= 0);
    } else if (filterByResult === 'losses') {
      filtered = filtered.filter(entry => entry.returns < 0);
    }

    if (filterByDate) {
      filtered = filtered.filter(entry => {
        const entryDate = new Date(entry.date);
        const filterDate = new Date(filterByDate);
        return entryDate.toDateString() === filterDate.toDateString();
      });
    }

    const today = new Date();
    if (subFilterByDate === 'today') {
      filtered = filtered.filter(entry => {
        const entryDate = new Date(entry.date);
        return entryDate.toDateString() === today.toDateString();
      });
    } else if (subFilterByDate === 'week') {
      const startOfWeekDate = startOfWeek(today);
      const endOfWeekDate = endOfWeek(today);
      filtered = filtered.filter(entry => isWithinInterval(new Date(entry.date), { start: startOfWeekDate, end: endOfWeekDate }));
    } else if (subFilterByDate === 'month') {
      const startDate = startOfMonth(today);
      const endDate = endOfMonth(today);
      filtered = filtered.filter(entry => isWithinInterval(new Date(entry.date), { start: startDate, end: endDate }));
    } else if (subFilterByDate === 'year') {
      const startOfYearDate = startOfYear(today);
      const endOfYearDate = endOfYear(today);
      filtered = filtered.filter(entry => isWithinInterval(new Date(entry.date), { start: startOfYearDate, end: endOfYearDate }));
    }

    if (filterByMonth !== "All" || filterByYear !== "All") {
      filtered = filtered.filter((entry) => {
        const entryDate = new Date(entry.date);
        const entryMonth = entryDate.getUTCMonth() + 1;
        const entryYear = entryDate.getUTCFullYear();
        return (
          (filterByMonth === "All" || entryMonth === parseInt(filterByMonth)) &&
          (filterByYear === "All" || entryYear === parseInt(filterByYear))
        );
      });
    }

    return filtered;
  };

const sortedEntries = () => {
  if (!sortBy) return filteredEntries();

  const multiplier = sortOrder === "asc" ? 1 : -1;

  return filteredEntries().sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];

    // ✅ Sort: Type column (Shares / Contracts / Lots / $)
    if (sortBy === "sizeType") {
      aValue = getTradeTypeLabel(a);
      bValue = getTradeTypeLabel(b);
      return aValue.localeCompare(bValue) * multiplier;
    }

    // ✅ Sort: Position Size column (shares/contracts/lots/$ amount)
    if (sortBy === "lotSizeEntry") {
      aValue = getPositionSortValue(a);
      bValue = getPositionSortValue(b);
      return (aValue - bValue) * multiplier;
    }

    // ✅ Better date sorting (optional but recommended)
    if (sortBy === "entryDateTime" || sortBy === "exitDateTime") {
      const aTime = aValue && aValue !== "N/A" ? new Date(aValue).getTime() : -Infinity;
      const bTime = bValue && bValue !== "N/A" ? new Date(bValue).getTime() : -Infinity;
      return (aTime - bTime) * multiplier;
    }

    // Existing fxbTradeScore sorting
    if (sortBy === "fxbTradeScore") {
      aValue = aValue === "N/A" ? -Infinity : parseInt(aValue.split("/")[0], 10);
      bValue = bValue === "N/A" ? -Infinity : parseInt(bValue.split("/")[0], 10);
      return (aValue - bValue) * multiplier;
    }

    // Existing numeric/string sorting
    if (typeof aValue === "number" && typeof bValue === "number") {
      return (aValue - bValue) * multiplier;
    } else if (typeof aValue === "string" && typeof bValue === "string") {
      return aValue.localeCompare(bValue) * multiplier;
    }

    return 0;
  });
};

  useEffect(() => {
    if (showModal || isChecklistModalOpen || showManualOverrideModal || showMoveTradeModal || showTradingViewModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [showModal, isChecklistModalOpen, showManualOverrideModal, showMoveTradeModal, showTradingViewModal]);

  const renderSortIndicator = (header) => {
    if (sortBy === header) {
      return sortOrder === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const isReplayAvailable = (trade) => {
    // Return false if trade is null, undefined, or missing exitDateTime
    if (!trade || !trade.exitDateTime) return false;
    const exitTime = new Date(trade.exitDateTime).getTime();
    const now = Date.now();
    return now - exitTime >= 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  };

  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'Users', userID));
        if (userDoc.exists() && userDoc.data().checklistEnabled === true) {
          const checklistDoc = await getDoc(doc(db, 'Users', userID, 'checklists', 'primary'));
          if (checklistDoc.exists()) {
            const checklistData = checklistDoc.data();
            if (checklistData.enabled === true) {
              setChecklist(checklistData);
            } else {
              setChecklist(null);
            }
          }
        } else {
          setChecklist(null);
        }
      } catch (error) {
        console.error('Error fetching checklist:', error);
        setChecklist(null);
      }
    };
    fetchChecklist();
  }, [userID]);

const modalPreview = selectedTrade
  ? (
      (selectedTrade.tradingViewUrls && selectedTrade.tradingViewUrls[previewTimeframe]) ||
      selectedTrade.tradingViewUrls?.htf ||
      selectedTrade.tradingViewUrls?.ltf ||
      selectedTrade.tradingViewUrls?.extra||
      selectedTrade.screenshot ||
      null
    )
  : null;
  
  const calculateChecklistScore = () => {
    if (!checklist || !checklist.items) return 0;
    const totalScore = checklist.items.reduce((sum, item, index) => {
      return sum + (checklistResponses[index] ? parseFloat(item.weight) : 0);
    }, 0);
    return Math.round(totalScore);
  };


const getPositionSizeDisplay = (trade) => {
  const assetType = detectAssetType(trade.symbol);

  // ------------------
  // EQUITIES
  // ------------------
  if (assetType === "equity") {
    const shares = Number(trade.shareCount || 0);
    return `${shares} ${shares === 1 ? "Share" : "Shares"}`;
  }

  // ------------------
  // FUTURES
  // ------------------
  if (assetType === "futures") {
    const contracts = Number(trade.lotSizeEntry || 0);
    return `${contracts} ${contracts === 1 ? "Contract" : "Contracts"}`;
  }

// ------------------
// FOREX
// ------------------
if (trade.sizeType === "lot") {
  const lots = Number(trade.lotSizeEntry || 0);

  // Remove unnecessary trailing zeros (1.00 → 1, 1.70 → 1.7)
  const formattedLots = lots % 1 === 0 
    ? lots.toString()
    : lots.toString().replace(/\.?0+$/, '');

  return `${formattedLots} ${lots === 1 ? "Lot" : "Lots"}`;
}

  if (trade.sizeType === "dollar") {
    const dollars = Number(trade.sizeAmount || 0);
    return `$${dollars.toLocaleString()}`;
  }

  return "N/A";
};

const getPositionSortValue = (trade) => {
  const assetType = detectAssetType(trade.symbol);

  // Equity -> shares
  if (assetType === "equity") {
    return parseFloat(trade.shareCount ?? 0) || 0;
  }

  // Futures -> contracts (you’re storing these in lotSizeEntry)
  if (assetType === "futures") {
    return parseFloat(trade.lotSizeEntry ?? 0) || 0;
  }

  // Forex -> lot size or dollar size
  if (trade.sizeType === "lot") {
    return parseFloat(trade.lotSizeEntry ?? 0) || 0;
  }

  if (trade.sizeType === "dollar") {
    return parseFloat(trade.sizeAmount ?? 0) || 0;
  }

  return 0;
};

const getTradeTypeLabel = (trade) => {
  const assetType = detectAssetType(trade.symbol);

  if (assetType === "equity") return "Shares";
  if (assetType === "futures") return "Contracts";

  // Forex
  if (trade.sizeType === "lot") return "Lots";
  if (trade.sizeType === "dollar") return "$";

  return "N/A";
};

const getMoveLabel = (trade) => {
  const assetType = detectAssetType(trade.symbol);
  if (assetType === "futures") return "Ticks";
  if (assetType === "equity") return "Price Move";
  return "Pips"; // forex/default
};

const getMoveValue = (trade) => {
  const entry = parseFloat(trade.entry);
  const exit = parseFloat(trade.exit);

  if (isNaN(entry) || isNaN(exit)) return "N/A";

  const assetType = detectAssetType(trade.symbol);

  // Futures: tick count (e.g. ES_F: 0.25 tick size -> 2.00 points = 8 ticks)
  if (assetType === "futures") {
    const inc = calculatePipIncrement(trade.symbol);
    if (!inc || isNaN(inc) || inc === 0) return "N/A";
    return Math.abs((entry - exit) / inc).toFixed(0);
  }

  // Equity: show raw move
  if (assetType === "equity") {
    const move = Math.abs(exit - entry);
    return move % 1 === 0 ? move.toString() : move.toString().replace(/\.?0+$/, "");
  }

  // Forex: pips (keep current behaviour)
  const inc = calculatePipIncrement(trade.symbol);
  if (!inc || isNaN(inc) || inc === 0) return "N/A";
  return Math.abs((entry - exit) / inc).toFixed(0);
};

  return (
    <div className="journal-table">
      <Typography variant="h5" component="h2" gutterBottom>
        User Journal Table
      </Typography>
      <MDBox
        display="flex"
        flexDirection="row"
        alignItems="center"
        sx={{
          width: '100%',
          flexWrap: 'wrap',
          gap: '8px',
          padding: '8px 0',
          '& > *': {
            flex: '1 1 150px',
            minWidth: '80px',
            maxWidth: '120px',
          },
          '& .delete-button': {
            flex: '0 0 auto',
            display: 'flex',
            gap: '8px',
            minWidth: '300px',
          },
          '@media (max-width: 600px)': {
            '& > *': {
              flex: '1 1 100%',
              maxWidth: 'none',
            },
            '& .delete-button': {
              minWidth: '100%',
            },
          },
        }}
      >
        <MDBox className="delete-button">
          <MDButton
            variant="contained"
            onClick={handleBulkDelete}
            disabled={selectedEntries.length === 0}
            startIcon={<Delete />}
            sx={{
              height: '36px',
              padding: '0 12px',
              borderRadius: '6px',
              backgroundColor: '#800020',
              color: '#fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              '&:hover': {
                backgroundColor: '#9b2a3a',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              },
              '&:disabled': {
                backgroundColor: '#4a1a1f',
                opacity: 0.6,
                boxShadow: 'none',
              },
            }}
          >
            Delete Selected
          </MDButton>
          <MDButton
            variant="contained"
            onClick={handleMassEditStart}
            disabled={selectedEntries.length === 0}
            startIcon={<Edit />}
            sx={{
              height: '36px',
              padding: '0 12px',
              borderRadius: '6px',
              backgroundColor: '#1d3557',
              color: '#fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              '&:hover': {
                backgroundColor: '#2a4a7a',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              },
              '&:disabled': {
                backgroundColor: '#15233d',
                opacity: 0.6,
                boxShadow: 'none',
              },
            }}
          >
            Mass Edit
          </MDButton>
          <MDButton
  variant="contained"
  onClick={() => {
    if (selectedEntries.length === 0) {
      alert('Please select at least one trade to move.');
      return;
    }
    setTradesToMove(selectedEntries);
    setShowMoveTradeModal(true);
  }}
  disabled={selectedEntries.length === 0}
  startIcon={<FindReplace />}
  sx={{
    height: '36px',
    padding: '0 12px',
    borderRadius: '6px',
    backgroundColor: '#2a9d8f',
    color: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: '#3ab4a6',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    },
    '&:disabled': {
      backgroundColor: '#1a645a',
      opacity: 0.6,
      boxShadow: 'none',
    },
  }}
>
  Move Selected
</MDButton>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Symbol</InputLabel>
            <Select
              value={filterBySymbol === '' ? 'All' : filterBySymbol}
              onChange={(e) => handleFilterBySymbol(e.target.value)}
              label="Filter by Symbol"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              {uniqueSymbols.map(symbol => (
                <MenuItem key={symbol} value={symbol}>{symbol}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Status</InputLabel>
            <Select
              value={filterByStatus === '' ? 'All' : filterByStatus}
              onChange={(e) => handleFilterByStatus(e.target.value)}
              label="Filter by Status"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              {uniqueStatus.map(status => (
                <MenuItem key={status} value={status}>{status}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Result</InputLabel>
            <Select
              value={filterByResult === '' ? 'All' : filterByResult}
              onChange={(e) => handleFilterByResult(e.target.value)}
              label="Filter by Result"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              <MenuItem value="wins">Wins</MenuItem>
              <MenuItem value="losses">Losses</MenuItem>
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Confidence</InputLabel>
            <Select
              value={filterByConfidence === '' ? 'All' : filterByConfidence}
              onChange={(e) => handleFilterByConfidence(e.target.value)}
              label="Filter by Confidence"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              <MenuItem value="High">High</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="Low">Low</MenuItem>
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Tags</InputLabel>
            <Select
              value={filterByTags === '' ? 'All' : filterByTags}
              onChange={(e) => handleFilterByTags(e.target.value)}
              label="Filter by Tags"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              {uniqueTags.map(tag => (
                <MenuItem key={tag} value={tag}>{tag}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Trade Score</InputLabel>
            <Select
              value={filterByTradeScore}
              onChange={(e) => setFilterByTradeScore(e.target.value)}
              label="Filter by Trade Score"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              <MenuItem value="80-100">80-100</MenuItem>
              <MenuItem value="50-79">50-79</MenuItem>
              <MenuItem value="<50">{'<50'}</MenuItem>
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <TextField
            type="date"
            label="Filter by Date"
            value={filterByDate}
            onChange={(e) => handleFilterByDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            sx={{ '& .MuiInputBase-root': { height: '36px' } }}
          />
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Month</InputLabel>
            <Select
              value={filterByMonth}
              onChange={(e) => handleFilterByMonth(e.target.value)}
              label="Filter by Month"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              <MenuItem value="1">January</MenuItem>
              <MenuItem value="2">February</MenuItem>
              <MenuItem value="3">March</MenuItem>
              <MenuItem value="4">April</MenuItem>
              <MenuItem value="5">May</MenuItem>
              <MenuItem value="6">June</MenuItem>
              <MenuItem value="7">July</MenuItem>
              <MenuItem value="8">August</MenuItem>
              <MenuItem value="9">September</MenuItem>
              <MenuItem value="10">October</MenuItem>
              <MenuItem value="11">November</MenuItem>
              <MenuItem value="12">December</MenuItem>
            </Select>
          </FormControl>
        </MDBox>
        <MDBox flex="1 1 150px" minWidth="120px">
          <FormControl fullWidth variant="outlined">
            <InputLabel>Filter by Year</InputLabel>
            <Select
              value={filterByYear}
              onChange={(e) => handleFilterByYear(e.target.value)}
              label="Filter by Year"
              sx={{ height: '36px' }}
            >
              <MenuItem value="All"><em>All</em></MenuItem>
              {years.map(year => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
      </MDBox>
      <div
      ref={topScrollRef}
      className="top-scrollbar"
      onScroll={handleTopScroll}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
        marginBottom: '8px',
      }}
    >
      <div style={{ height: '1px', width: tableRef.current ? tableRef.current.scrollWidth : '100%' }}></div>
    </div>

    {/* Table Wrapper */}
    <div
      ref={tableWrapperRef}
      className="table-wrapper"
      onScroll={handleTableScroll}
      style={{
        overflowX: 'auto',
        width: '100%',
      }}
    >
      <table ref={tableRef}>
        <thead>
          <tr>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px' }}>
              <input type="checkbox" onChange={handleSelectAll} checked={selectedEntries.length === journalEntries.length && journalEntries.length > 0} />
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('entryDateTime')}>
              <MDTypography variant="h6" component="span">Entry Date {renderSortIndicator('entryDateTime')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('exitDateTime')}>
              <MDTypography variant="h6" component="span">Exit Date {renderSortIndicator('exitDateTime')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('symbol')}>
              <MDTypography variant="h6" component="span">Symbol {renderSortIndicator('symbol')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('entry')}>
              <MDTypography variant="h6" component="span">Entry {renderSortIndicator('entry')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('exit')}>
              <MDTypography variant="h6" component="span">Exit {renderSortIndicator('exit')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('leverage')}>
              <MDTypography variant="h6" component="span">Leverage {renderSortIndicator('leverage')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('sizeType')}>
                <MDTypography variant="h6" component="span">Type {renderSortIndicator('sizeType')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('lotSizeEntry')}>
                <MDTypography variant="h6" component="span">Position Size {renderSortIndicator('lotSizeEntry')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('shortLong')}>
              <MDTypography variant="h6" component="span">Short/Long {renderSortIndicator('shortLong')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('returns')}>
              <MDTypography variant="h6" component="span">Returns ($) {renderSortIndicator('returns')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('riskRewardRatio')}>
              <MDTypography variant="h6" component="span">Targeted RR {renderSortIndicator('riskRewardRatio')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('actualRRRatio')}>
              <MDTypography variant="h6" component="span">Actual RR {renderSortIndicator('actualRRRatio')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('status')}>
              <MDTypography variant="h6" component="span">Status {renderSortIndicator('status')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('tradeConfidence')}>
              <MDTypography variant="h6" component="span">Confidence {renderSortIndicator('tradeConfidence')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('tags')}>
              <MDTypography variant="h6" component="span">Tags {renderSortIndicator('tags')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('screenshot')}>
              <MDTypography variant="h6" component="span">Screenshot {renderSortIndicator('screenshot')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db' }} onClick={() => handleSort('fxbTradeScore')}>
              <MDTypography variant="h6" component="span">Trade Score {renderSortIndicator('fxbTradeScore')}</MDTypography>
            </th>
            <th style={{ backgroundColor: theme.palette.background.default || '#bac7db', borderTopRightRadius: '12px', borderBottomRightRadius: '12px' }}>
              <MDTypography variant="h6" onClick={(e) => e.stopPropagation()} component="span"></MDTypography>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedEntries().map((entry, index) => (
            <tr key={index} onClick={() => handleRowClick(entry)}>
              <td><input type="checkbox" checked={selectedEntries.includes(entry.id)} onClick={(e) => e.stopPropagation()} onChange={(e) => handleSelectEntry(e, entry.id)} /></td>
              <td className="date-cell">
                <span>
                  <MDTypography variant="body3">
                    {entry.entryDateTime !== 'N/A' && !isNaN(new Date(entry.entryDateTime).getTime())
                      ? new Date(entry.entryDateTime).toLocaleDateString()
                      : 'N/A'}
                  </MDTypography>
                </span>
                <span>
                  <MDTypography variant="body3">
                    {entry.entryDateTime !== 'N/A' && !isNaN(new Date(entry.entryDateTime).getTime())
                      ? new Date(entry.entryDateTime).toLocaleTimeString()
                      : ''}
                  </MDTypography>
                </span>
              </td>
              <td className="date-cell">
                <span>
                  <MDTypography variant="body3">
                    {entry.exitDateTime !== 'N/A' && !isNaN(new Date(entry.exitDateTime).getTime())
                      ? new Date(entry.exitDateTime).toLocaleDateString()
                      : 'N/A'}
                  </MDTypography>
                </span>
                <span>
                  <MDTypography variant="body3">
                    {entry.exitDateTime !== 'N/A' && !isNaN(new Date(entry.exitDateTime).getTime())
                      ? new Date(entry.exitDateTime).toLocaleTimeString()
                      : ''}
                  </MDTypography>
                </span>
              </td>
              <td><MDTypography variant="body3">{entry.symbol}</MDTypography></td>
              <td><MDTypography variant="body3">{entry.entry}</MDTypography></td>
              <td><MDTypography variant="body3">{entry.exit}</MDTypography></td>
              <td><MDTypography variant="body3">x{entry.leverage}</MDTypography></td>
<td>
  <MDTypography variant="body3">
    {getTradeTypeLabel(entry)}
  </MDTypography>
</td>

<td>
  <MDTypography variant="body3">
    {getPositionSizeDisplay(entry)}
  </MDTypography>
</td>
              <td><MDTypography variant="body3">{entry.shortLong}</MDTypography></td>
              <td className={`return ${entry.returns > 0 ? 'positive' : entry.returns < 0 ? 'negative' : 'breakeven'}`}>
                ${!isNaN(parseFloat(entry.returns)) ? parseFloat(entry.returns).toFixed(2) : 'N/A'}
              </td>
              <td><MDTypography variant="body3">{entry.riskRewardRatio.toFixed(2)}</MDTypography></td>
              <td><MDTypography variant="body3">{entry.actualRRRatio}</MDTypography></td>
              <td><MDTypography variant="body3">{entry.status}</MDTypography></td>
              <td>{getConfidenceIcon(entry.tradeConfidence)}</td>
              <td><MDTypography variant="body3">{Array.isArray(entry.tags) && entry.tags.length > 0 ? entry.tags.join(', ') : 'N/A'}</MDTypography></td>
              <td>
  {getPreviewUrl(entry) ? (
    <img src={getPreviewUrl(entry)} alt="TradingView Chart" style={{ width: '100px', height: 'auto' }} onError={(e) => e.target.src = 'path/to/fallback-image.png'} />
  ) : entry.screenshot ? (
    <img src={entry.screenshot} alt="Screenshot" style={{ width: '100px', height: 'auto' }} />
  ) : (
    <MDTypography variant="body3">No Screenshot</MDTypography>
  )}
</td>
              <td>{renderTradeScore(entry.fxbTradeScore)}</td>
              <td>
                <div onClick={(e) => e.stopPropagation()}>
                  <IconButton onClick={(e) => { e.stopPropagation(); handleMenuOpen(e, entry); }} style={{ color: iconColor }}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={(e) => { e.stopPropagation(); handleDelete(selectedTrade.id); handleMenuClose(); }}>
                      <Delete style={{ marginRight: 8 }} /> Delete
                    </MenuItem>
                    <MenuItem onClick={(e) => { e.stopPropagation(); handleEdit(selectedTrade); handleMenuClose(); }}>
                      <Edit style={{ marginRight: 8 }} /> Edit
                    </MenuItem>
                    <MenuItem>
                      <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <UploadIcon style={{ marginRight: 8 }} /> Upload
                        <input
                          accept="image/*"
                          type="file"
                          hidden
                          onChange={(e) => { handleUploadImage(selectedTrade.id, e.target.files[0]); handleMenuClose(); }}
                        />
                      </label>
                    </MenuItem>
                    <MenuItem
    onClick={(e) => {
      e.stopPropagation();
      if (selectedTrade) {
        setTradingViewTradeID(selectedTrade.id);
        setShowTradingViewModal(true);
      }
      handleMenuClose();
    }}
  >
    <UploadIcon style={{ marginRight: 8 }} /> Add HTF / LTF TradingView Link
  </MenuItem>
                    <MenuItem
  onClick={(e) => {
    e.stopPropagation();
    setTradesToMove([selectedTrade.id]);
    setShowMoveTradeModal(true);
    handleMenuClose();
  }}
>
  <FindReplace style={{ marginRight: 8 }} /> Move Trade
</MenuItem>

  <MenuItem
    onClick={(e) => {
      e.stopPropagation();
      handleManualOverride(selectedTrade);
      handleMenuClose();
    }}
  >
    <Edit style={{ marginRight: 8 }} /> Manual Override
  </MenuItem>
                    <Tooltip
  title={
    !isReplayAvailable(selectedTrade)
      ? "Trade Replay is available 24 hours after the trade's exit to process optimal entry, exit, stop loss, and take profit data."
      : ""
  }
  placement="left"
  arrow
  sx={{
    "& .MuiTooltip-tooltip": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      fontSize: "0.75rem",
      borderRadius: "4px",
      boxShadow: theme.shadows[3],
    },
    "& .MuiTooltip-arrow": {
      color: theme.palette.background.paper,
    },
  }}
>
  <span>
    <MenuItem
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/fx-dashboard/trade-replay/${selectedTrade.id}`, { state: selectedTrade });
        console.log('Navigating with selectedTrade:', selectedTrade);
        handleMenuClose();
      }}
      disabled={!isReplayAvailable(selectedTrade)}
    >
      <WaterfallChartIcon style={{ marginRight: 8 }} /> Go to Trade Replay
    </MenuItem>
  </span>
</Tooltip>
                  </Menu>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      {showModal && (
        <div className="modal-journal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, overflow: 'auto', }}    onClick={() => {
          setShowModal(false);
          setCurrentMassEditTrade(null);
        }}>
    <div
      style={{
        padding: '16px',
        backgroundColor: theme.palette.background.default,
        width: '100%',
        maxWidth: '400px', // Limit max width for larger screens
        minWidth: '280px', // Minimum width for very small screens
        height: 'auto',
        maxHeight: '70vh', // Slightly reduced to fit better
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        overflowY: 'auto', // Enable scrolling within the modal
        color: theme.palette.text.primary,
        boxSizing: 'border-box',
        '@media (max-width: 600px)': {
          padding: '12px', // Reduce padding on small screens
          maxWidth: '90vw', // Use viewport width for responsiveness
        },
      }}
      className="modal-content-journal"
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
    >
      <MDTypography
        variant="h3"
        style={{
          fontSize: '1.5rem',
          marginBottom: '10px',
          '@media (max-width: 600px)': {
            fontSize: '1.25rem', // Smaller font size on mobile
          },
        }}
      >
              {currentMassEditTrade
                ? `Mass Edit Trade ${currentMassEditTrade.index + 1} of ${selectedEntries.length} (${date || 'N/A'})`
                : `Edit Entry for ${date || 'N/A'}`}
            </MDTypography>
            <MDBox display="flex" flexDirection="column" gap="10px">
              <MDInput type="number" value={entry} onChange={(e) => setEntry(e.target.value)} label="Entry Price" variant="outlined" fullWidth />
              <TextField
                type="number"
                value={exit}
                onChange={(e) => setExit(e.target.value)}
                label="Exit Price"
                variant="outlined"
                fullWidth
                disabled={status !== 'Closed' && status !== 'Missed'}
                placeholder={status !== 'Closed' && status !== 'Missed' ? 'Set status to Closed/Missed to enable' : ''}
                sx={{
                  '& .MuiInputBase-root.Mui-disabled': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : theme.palette.action.disabledBackground,
                    color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                    '& .MuiOutlinedInput-input::placeholder': {
                      color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                      opacity: 1,
                    },
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                }}
              />
              <MDInput
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                label="Entry Date"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <MDInput
                type="time"
                value={entryTime}
                onChange={(e) => setEntryTime(e.target.value)}
                label="Entry Time"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                type="date"
                value={exitDate}
                onChange={(e) => setExitDate(e.target.value)}
                label="Exit Date"
                variant="outlined"
                fullWidth
                disabled={status !== 'Closed' && status !== 'Missed'}
                placeholder={status !== 'Closed' && status !== 'Missed' ? 'Set status to Closed/Missed to enable' : ''}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root.Mui-disabled': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : theme.palette.action.disabledBackground,
                    color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                    '& .MuiOutlinedInput-input::placeholder': {
                      color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                      opacity: 1,
                    },
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                }}
              />
              <TextField
                type="time"
                value={exitTime}
                onChange={(e) => setExitTime(e.target.value)}
                label="Exit Time"
                variant="outlined"
                fullWidth
                disabled={status !== 'Closed' && status !== 'Missed'}
                placeholder={status !== 'Closed' && status !== 'Missed' ? 'Set status to Closed/Missed to enable' : ''}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiInputBase-root.Mui-disabled': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : theme.palette.action.disabledBackground,
                    color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                    '& .MuiOutlinedInput-input::placeholder': {
                      color: theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600],
                      opacity: 1,
                    },
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ffffff',
                  },
                }}
              />
              <MDInput type="text" value={updatedSlValue} onChange={(e) => setUpdatedSlValue(e.target.value)} label="Stop Loss" variant="outlined" fullWidth />
              <MDInput type="text" value={tp} onChange={(e) => setTp(e.target.value)} label="Take Profit" variant="outlined" fullWidth />
              <MDInput type="text" value={comments} onChange={(e) => setComments(e.target.value)} label="Comments" variant="outlined" fullWidth />
              <FormControl fullWidth variant="outlined">
                <InputLabel>Trade Confidence</InputLabel>
                <Select
                  value={tradeConfidence}
                  onChange={(e) => setTradeConfidence(e.target.value)}
                  label="Trade Confidence"
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  <MenuItem value="High"><SentimentVerySatisfiedIcon style={{ color: 'green', marginRight: '8px' }} /> High</MenuItem>
                  <MenuItem value="Medium"><SentimentSatisfiedIcon style={{ color: 'orange', marginRight: '8px' }} /> Medium</MenuItem>
                  <MenuItem value="Low"><SentimentDissatisfiedIcon style={{ color: 'red', marginRight: '8px' }} /> Low</MenuItem>
                </Select>
              </FormControl>
              <Select
                value={status}
                onChange={(e) => {
                  const newStatus = e.target.value;
                  setStatus(newStatus);
                  if (newStatus !== 'Closed' && newStatus !== 'Missed') {
                    setExit('');
                    setExitDate('');
                    setExitTime('');
                  }
                }}
                label="Status"
                fullWidth
              >
                <MenuItem value="Open">Open</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Missed">Missed</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
              </Select>
              <MDInput type="text" value={tags} onChange={handleTagChange} label="Tags (comma-separated)" variant="outlined" fullWidth />
<MDInput
  fullWidth
  label="TradingView HTF"
  value={tradingViewUrls.htf}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, htf: e.target.value }))
  }
/>

<MDInput
  sx={{ mt: 2 }}
  fullWidth
  label="TradingView LTF"
  value={tradingViewUrls.ltf}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, ltf: e.target.value }))
  }
/>
<MDInput
  sx={{ mt: 2 }}
  fullWidth
  label="TradingView Extra/Focus"
  value={tradingViewUrls.extra}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, extra: e.target.value }))
  }
/>
              {!containsUSD && (
                <MDInput type="number" value={exchangeRate} onChange={(e) => setExchangeRate(e.target.value)} label="Exchange Rate" variant="outlined" fullWidth />
              )}
                      {/* Add Trade Score and Edit Checklist Button */}

        <MDButton
          variant="contained"
          color="info"
          onClick={() => {
            if (checklist) {
              setIsChecklistModalOpen(true);
            } else {
              alert('No checklist available for this trade.');
            }
          }}
          disabled={!checklist}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          Edit Checklist / FXB Trade Score
        </MDButton>
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end" mt={2} gap={1}>
              <MDButton
                variant="contained"
                onClick={handleUpdate}
                sx={{
                  height: '36px',
                  padding: '0 12px',
                  borderRadius: '6px',
                  backgroundColor: '#2a9d8f',
                  color: '#fff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  textTransform: 'none',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: '#3ab4a6',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                  },
                }}
              >
                {currentMassEditTrade && currentMassEditTrade.index < selectedEntries.length - 1 ? 'Next' : 'Update'}
              </MDButton>
              <MDButton
                variant="contained"
                onClick={() => {
                  setShowModal(false);
                  setCurrentMassEditTrade(null);
                }}
                sx={{
                  height: '36px',
                  padding: '0 12px',
                  borderRadius: '6px',
                  backgroundColor: '#606c88',
                  color: '#fff',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  textTransform: 'none',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: '#73809e',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                  },
                }}
              >
                Cancel
              </MDButton>
            </MDBox>
          </div>
        </div>
      )}
      {isChecklistModalOpen && checklist && (
  <div
    className="modal-journal"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1001, // Higher than Edit Modal
    }}
  >
    <div
      style={{
        padding: 16,
        backgroundColor: theme.palette.background.default,
        width: '400px',
        height: 'auto',
        maxHeight: '80vh',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        overflow: 'auto',
        color: theme.palette.text.primary,
      }}
      className="modal-content-journal"
    >
      <MDTypography
        variant="h3"
        style={{ fontSize: '1.5rem', marginBottom: '10px' }}
      >
        Trade Checklist: {checklist.name || 'Primary Checklist'}
      </MDTypography>
      <MDBox display="flex" flexDirection="column" gap="10px">
        {checklist.items.map((item, index) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                checked={checklistResponses[index] || false}
                onChange={(e) => {
                  const newResponses = [...checklistResponses];
                  newResponses[index] = e.target.checked;
                  setChecklistResponses(newResponses);
                }}
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-checked': {
                    color: '#2a9d8f',
                  },
                }}
              />
            }
            label={`${item.description} (${item.weight}%)`}
            sx={{
              color: theme.palette.text.primary,
              '& .MuiFormControlLabel-label': {
                fontSize: '0.875rem',
              },
            }}
          />
        ))}
      </MDBox>
      <MDTypography
        variant="body2"
        mt={2}
        color={
          calculateChecklistScore() > 79
            ? 'success'
            : calculateChecklistScore() >= 49
            ? 'warning'
            : 'error'
        }
      >
        Current FXB Trade Score: {calculateChecklistScore()}/100
      </MDTypography>
      <MDBox display="flex" justifyContent="flex-end" mt={2} gap={1}>
        <MDButton
          variant="contained"
          onClick={() => {
            const newScore = `${calculateChecklistScore()}/100`;
            setFxbTradeScore(newScore);
            setIsChecklistModalOpen(false);
          }}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#2a9d8f',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#3ab4a6',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Save Checklist
        </MDButton>
        <MDButton
          variant="contained"
          onClick={() => setIsChecklistModalOpen(false)}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#606c88',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#73809e',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Cancel
        </MDButton>
      </MDBox>
    </div>
  </div>
)}
      {showManualOverrideModal && (
        <div className="modal-journal">
          <div style={{ padding: 16, backgroundColor: theme.palette.background.default || '#bac7db' }} className="modal-content-journal-override">
            <MDTypography variant="h3">Set Manual Return Override for {date || 'N/A'}</MDTypography>
            <div>
              <MDTypography variant="body2">Set Your Dollar Return Override Value</MDTypography>
              <MDInput variant="outlined" type="number" value={manualOverrideValue} onChange={(e) => setManualOverrideValue(e.target.value)} label="Return" />
            </div>
            <MDButton type="submit" variant="gradient" color="info" onClick={confirmManualOverride} style={{ marginRight: '30px', marginTop: '30px' }}>Confirm</MDButton>
            <MDButton type="submit" variant="gradient" color="info" onClick={() => setShowManualOverrideModal(false)} style={{ marginRight: '30px', marginTop: '30px' }}>Close</MDButton>
          </div>
        </div>
      )}
{showMoveTradeModal && tradesToMove.length > 0 && (
  <div
    className="modal-journal"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000,
    }}
  >
    <div
      style={{
        padding: 16,
        backgroundColor: theme.palette.background.default,
        width: '300px',
        height: '300px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        color: theme.palette.text.primary,
      }}
      className="modal-content-journal"
    >
      <MDTypography variant="h3" style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
        Move Trade(s)
      </MDTypography>
      <MDTypography variant="body2" style={{ marginBottom: '10px' }}>
        Select the target account for {tradesToMove.length} trade(s).
      </MDTypography>
      <FormControl fullWidth variant="outlined">
        <InputLabel>Target Account</InputLabel>
        <Select
          value={targetAccountID}
          onChange={(e) => setTargetAccountID(e.target.value)}
          label="Target Account"
          sx={{ height: '36px' }}
        >
          <MenuItem value="">
            <em>Select an account</em>
          </MenuItem>
          {tradeAccounts && tradeAccounts.length > 0 ? (
            tradeAccounts
              .filter((account) => account.id !== selectedAccountID)
              .map((account) => (
                <MenuItem key={account.id} value={account.id}>
                  {account.name}
                </MenuItem>
              ))
          ) : (
            <MenuItem value="" disabled>
              No accounts available
            </MenuItem>
          )}
        </Select>
      </FormControl>
      <MDBox display="flex" justifyContent="flex-end" mt={2} gap={1}>
        <MDButton
          variant="contained"
          onClick={() => handleMoveTrades(tradesToMove)}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#2a9d8f',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#3ab4a6',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Move
        </MDButton>
        <MDButton
          variant="contained"
          onClick={() => {
            setShowMoveTradeModal(false);
            setTradesToMove([]);
            setTargetAccountID('');
          }}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#606c88',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#73809e',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Cancel
        </MDButton>
      </MDBox>
    </div>
  </div>
)}
{showTradingViewModal && (
  <div
    className="modal-journal"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1000,
    }}
  >
    <div
      style={{
        padding: 16,
        backgroundColor: theme.palette.background.default,
        width: '400px',
        height: '200px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        color: theme.palette.text.primary,
      }}
      className="modal-content-journal"
    >
      <MDTypography variant="h3" style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
        Add TradingView Chart URL
      </MDTypography>
<MDInput
  fullWidth
  label="TradingView HTF"
  value={tradingViewUrls.htf}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, htf: e.target.value }))
  }
/>

<MDInput
  sx={{ mt: 2 }}
  fullWidth
  label="TradingView LTF"
  value={tradingViewUrls.ltf}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, ltf: e.target.value }))
  }
/>
<MDInput
  sx={{ mt: 2 }}
  fullWidth
  label="TradingView Extra/Focus"
  value={tradingViewUrls.extra}
  onChange={(e) =>
    setTradingViewUrls(prev => ({ ...prev, extra: e.target.value }))
  }
/>
      <MDBox display="flex" justifyContent="flex-end" mt={2} gap={1}>
        <MDButton
          variant="contained"
          onClick={handleSaveTradingViewUrl}
          disabled={!tradingViewTradeID}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#2a9d8f',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#3ab4a6',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Save
        </MDButton>
        <MDButton
          variant="contained"
          onClick={() => {
            setShowTradingViewModal(false);
            setTempTradingViewUrl('');
            setTradingViewTradeID(null);
          }}
          sx={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '6px',
            backgroundColor: '#606c88',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#73809e',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            },
          }}
        >
          Cancel
        </MDButton>
      </MDBox>
    </div>
  </div>
)}
    {isModalOpen && selectedTrade && (
      <Paper
        style={{
          padding: 16,
          marginRight: '15px',
          backgroundColor: theme.palette.background.default || '#bac7db',
          position: 'fixed',
          top: '53%',
          left: '55%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
        }}
        className="modal-journal-image"
      >
        <div className="modal-content-journal-image" style={{ display: 'flex', width: '80%', position: 'relative', maxHeight: '85vh', overflowY: 'auto' }}>
          <div style={{ flex: 0.5, paddingRight: '20px' }}>
            <MDTypography variant="h4">Selected Trade Entry</MDTypography>
            <MDTypography variant="body2">Entry Date and Time: {selectedTrade.entryDateTime !== 'N/A' ? new Date(selectedTrade.entryDateTime).toLocaleString() : 'N/A'}</MDTypography>
            <MDTypography variant="body2">Exit Date and Time: {selectedTrade.exitDate ? new Date(selectedTrade.exitDate + 'T' + (selectedTrade.exitTime || '00:00')).toLocaleString() : 'N/A'}</MDTypography>
            <MDTypography variant="body2">Hold Time: {calculateHoldTime(selectedTrade.entryDateTime, selectedTrade.exitDate, selectedTrade.exitTime)}</MDTypography>
            <MDTypography variant="body2">Symbol: {selectedTrade.symbol}</MDTypography>
            <MDTypography variant="body2">Entry: {selectedTrade.entry}</MDTypography>
            <MDTypography variant="body2">Exit: {selectedTrade.exit}</MDTypography>
            <MDTypography variant="body2">SL: {selectedTrade.sl}</MDTypography>
            <MDTypography variant="body2">TP: {selectedTrade.tp}</MDTypography>
            <MDTypography variant="body2">
  {getMoveLabel(selectedTrade)}: {getMoveValue(selectedTrade)}
</MDTypography>
            <MDTypography variant="body2">Leverage: {selectedTrade.leverage}</MDTypography>
<MDTypography variant="body2">
  Type: {getTradeTypeLabel(selectedTrade)}
</MDTypography>
            <MDBox display="flex" flexDirection="row">
<MDTypography variant="body2">
  Position Size: {getPositionSizeDisplay(selectedTrade)}
</MDTypography>
            </MDBox>
            <MDTypography variant="body2">Short/Long: {selectedTrade.shortLong}</MDTypography>
            <MDTypography variant="body2">Returns $: {selectedTrade.returns.toFixed(2)}</MDTypography>
            {detectAssetType(selectedTrade.symbol) !== "futures" && (
  <MDTypography variant="body2">
    Return %: {Number(selectedTrade.returnPercentage || 0).toFixed(2)}
  </MDTypography>
)}
            <MDTypography variant="body2">Risk Amount $: {selectedTrade.riskAmount.toFixed(2)}</MDTypography>
            <MDTypography variant="body2">Targeted RR: {selectedTrade.riskRewardRatio}</MDTypography>
            <MDTypography variant="body2">Actual RR: {selectedTrade.actualRRRatio}</MDTypography>
            <MDTypography variant="body2">Status: {selectedTrade.status}</MDTypography>
            <MDTypography variant="body2">Trade Confidence: {getConfidenceIcon(selectedTrade.tradeConfidence)}</MDTypography>
            <MDTypography variant="body2">Trade Score: {renderTradeScore(selectedTrade.fxbTradeScore)}</MDTypography>
            <MDTypography variant="body2">Tags: {Array.isArray(selectedTrade.tags) && selectedTrade.tags.length > 0 ? selectedTrade.tags.join(', ') : 'N/A'}</MDTypography>
            <MDTypography variant="body2">Commission Fee: {selectedTrade.commission}</MDTypography>
            <MDTypography variant="body2">Comments: {selectedTrade.comments}</MDTypography>
          </div>
          <div style={{ flex: 2.5 }}>
        <span className="close" onClick={closeModal}>×</span>
<MDBox sx={{ display: 'flex', gap: 1, mb: 2 }}>
  <MDButton
    size="small"
    variant={previewTimeframe === 'htf' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('htf')}
    disabled={
      !selectedTrade?.tradingViewUrls ||
      !selectedTrade.tradingViewUrls.htf ||
      selectedTrade.tradingViewUrls.htf.trim() === ''
    }
  >
    HTF
  </MDButton>
  <MDButton
    size="small"
    variant={previewTimeframe === 'ltf' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('ltf')}
    disabled={
      !selectedTrade?.tradingViewUrls ||
      !selectedTrade.tradingViewUrls.ltf ||
      selectedTrade.tradingViewUrls.ltf.trim() === ''
    }
  >
    LTF
  </MDButton>
    <MDButton
    size="small"
    variant={previewTimeframe === 'extra' ? 'contained' : 'outlined'}
    onClick={() => setPreviewTimeframe('extra')}
    disabled={
      !selectedTrade?.tradingViewUrls ||
      !selectedTrade.tradingViewUrls.extra ||
      selectedTrade.tradingViewUrls.extra.trim() === ''
    }
  >
    Extra/Focus
  </MDButton>
</MDBox>
{modalPreview ? (
  <img src={modalPreview} style={{ width: '100%' }} />
) : (
  <MDTypography>No Screenshot or TradingView Chart Available</MDTypography>
)}
      </div>
        </div>
      </Paper>
    )}
  </div>
);
};

JournalTable.propTypes = {
  userID: PropTypes.string.isRequired,
  selectedAccountID: PropTypes.string.isRequired,
  tradeAccounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
export default JournalTable;